module.exports = __webpack_public_path__ + "resources/img/sp_solution_app_m.35e0a12c5dfdc055c4627f296543c551.png";